/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Row2_CostInputs */

const en_mk_model_row2_cost = /** @type {(inputs: Mk_Model_Row2_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Rp2,800/draft`)
};

const id_mk_model_row2_cost = /** @type {(inputs: Mk_Model_Row2_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Rp2.800/draf`)
};

/**
* | output |
* | --- |
* | "≈ Rp2,800/draft" |
*
* @param {Mk_Model_Row2_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_row2_cost = /** @type {((inputs?: Mk_Model_Row2_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Row2_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_row2_cost(inputs)
	return en_mk_model_row2_cost(inputs)
});